<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="ph"><i class="calibre7">To Phyllida</i></p>
</div>
<div class="calibre8" id="calibre_pb_1"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section003_split_000.vue?150f437c